"use client";
import { jsxs as h, jsx as l } from "react/jsx-runtime";
const r = ({
  title: i,
  titleId: f,
  desc: a,
  descId: d,
  ...t
}) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-si",
    viewBox: "0 0 640 480",
    "aria-labelledby": f,
    "aria-describedby": d,
    ...t,
    children: [
      a ? /* @__PURE__ */ l("desc", { id: d, children: a }) : null,
      i ? /* @__PURE__ */ l("title", { id: f, children: i }) : null,
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "si-a", children: /* @__PURE__ */ l("path", { fillOpacity: 0.7, d: "M-15 0h682.6v512H-15.1z" }) }) }),
      /* @__PURE__ */ h(
        "g",
        {
          fillRule: "evenodd",
          strokeWidth: "1pt",
          clipPath: "url(#si-a)",
          transform: "translate(14.1)scale(.9375)",
          children: [
            /* @__PURE__ */ l("path", { fill: "#fff", d: "M-62 0H962v512H-62z" }),
            /* @__PURE__ */ l("path", { fill: "#d50000", d: "M-62 341.3H962V512H-62z" }),
            /* @__PURE__ */ l("path", { fill: "#0000bf", d: "M-62 170.7H962v170.6H-62z" }),
            /* @__PURE__ */ l(
              "path",
              {
                fill: "#d50000",
                d: "M228.4 93c-4 61.6-6.4 95.4-15.7 111-10.2 16.8-20 29.1-59.7 44-39.6-14.9-49.4-27.2-59.6-44-9.4-15.6-11.7-49.4-15.7-111l5.8-2c11.8-3.6 20.6-6.5 27.1-7.8 9.3-2 17.3-4.2 42.3-4.7 25 .4 33 2.8 42.3 4.8 6.4 1.4 15.6 4 27.3 7.7z"
              }
            ),
            /* @__PURE__ */ l(
              "path",
              {
                fill: "#0000bf",
                d: "M222.6 91c-3.8 61.5-7 89.7-12 103.2-9.6 23.2-24.8 35.9-57.6 48-32.8-12.1-48-24.8-57.7-48-5-13.6-8-41.7-11.8-103.3 11.6-3.6 20.6-6.4 27.1-7.7 9.3-2 17.3-4.3 42.3-4.7 25 .4 33 2.7 42.3 4.7a284 284 0 0 1 27.4 7.7z"
              }
            ),
            /* @__PURE__ */ l(
              "path",
              {
                fill: "#ffdf00",
                d: "m153 109.8 1.5 3.7 7 1-4.5 2.7 4.3 2.9-6.3 1-2 3.4-2-3.5-6-.8 4-3-4.2-2.7 6.7-1z"
              }
            ),
            /* @__PURE__ */ l(
              "path",
              {
                fill: "#fff",
                d: "m208.3 179.6-3.9-3-2.7-4.6-5.4-4.7-2.9-4.7-5.4-4.9-2.6-4.7-3-2.3-1.8-1.9-5 4.3-2.6 4.7-3.3 3-3.7-2.9-2.7-4.8-10.3-18.3-10.3 18.3-2.7 4.8-3.7 2.9-3.3-3-2.7-4.7-4.9-4.3-1.9 1.8-2.9 2.4-2.6 4.7-5.4 4.9-2.9 4.7-5.4 4.7-2.7 4.6-3.9 3a65.8 65.8 0 0 0 18.6 36.3 107 107 0 0 0 36.6 20.5 104.1 104.1 0 0 0 36.8-20.5c5.8-6 16.6-19.3 18.6-36.3"
              }
            ),
            /* @__PURE__ */ l(
              "path",
              {
                fill: "#ffdf00",
                d: "m169.4 83.9 1.6 3.7 7 1-4.6 2.7 4.4 2.9-6.3 1-2 3.4-2-3.5-6-.8 4-3-4.2-2.7 6.6-1zm-33 0 1.6 3.7 7 .9-4.5 2.7 4.3 2.9-6.3 1-2 3.4-2-3.4-6-.9 4-3-4.2-2.7 6.7-1z"
              }
            ),
            /* @__PURE__ */ l(
              "path",
              {
                fill: "#0000bf",
                d: "M199.7 203h-7.4l-7-.5-8.3-4h-9.4l-8.1 4-6.5.6-6.4-.6-8.1-4H129l-8.4 4-6.9.6-7.6-.1-3.6-6.2.1-.2 11.2 1.9 6.9-.5 8.3-4.1h9.4l8.2 4 6.4.6 6.5-.6 8.1-4h9.4l8.4 4 6.9.6 10.8-2 .2.4zm-86.4 9.5 7.4-.5 8.3-4h9.4l8.2 4 6.4.5 6.4-.5 8.2-4h9.4l8.3 4 7.5.5 4.8-6h-.1l-5.2 1.4-6.9-.5-8.3-4h-9.4l-8.2 4-6.4.6-6.5-.6-8.1-4H129l-8.4 4-6.9.6-5-1.3v.2l4.5 5.6z"
              }
            )
          ]
        }
      )
    ]
  }
);
export {
  r as default
};
